<script setup lang="ts">
const { siteOptions } = useSiteOptions();
</script>

<template>
  <UiNavButton v-if="siteOptions" as="a" :href="siteOptions.wishlist_url" label="Mes favoris">
    <span class="i-local-heart" />
  </UiNavButton>
</template>
